// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i3-a";
export var fulfillmentFormRail = "_i3-9";
export var headerTitleRow = "_i3-c";
export var orderDetailsWrapper = "_i3-7";
export var orderLinkTrigger = "_i3-2";
export var paymentInformationGrid = "_i3-h";
export var paymentSummaryColumn = "_i3-i";
export var shipmentContainer = "_i3-b";
export var shipmentDetailsMainPane = "_i3-8";
export var shipmentNavigationCard = "_i3-5";
export var shipmentNavigationRail = "_i3-3";
export var shipmentNavigationRailHeader = "_i3-4";
export var shipmentSummaryFact = "_i3-e";
export var shipmentSummaryGrid = "_i3-d";
export var shipmentSummaryMetadataRow = "_i3-f";
export var shipmentSummaryTags = "_i3-g";
export var shipmentWorkspace = "_i3-0";
export var shipmentWorkspaceContent = "_i3-6";
export var shipmentWorkspaceHeader = "_i3-1";